module.exports = __webpack_public_path__ + "718cbef68dd424b1c70932bf2e0fafb9.png";